export const env = { ...import.meta.env };
